import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setContentManagerSearchFilterType, setContentManagerSearchValue } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { FilterDismiss20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/FilterDismiss20Regular";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";

export function useMenuItem_ClearSearch(
  waitFor: boolean
) {
  const languageStrings = React.useContext(LanguageContext);
  const dispatch = useDispatch();

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);

  const onClearSearch = React.useCallback(() => {
    dispatch(setContentManagerSearchValue(""));
    dispatch(setContentManagerSearchFilterType(""));
  }, [dispatch]);

  const menuItem_ClearSearch = React.useMemo(() => {

    if (searchValue) {
      return {
        key: "clearSearch",
        text: languageStrings.ClearSearch,
        disabled: waitFor === true,
        // iconProps: { iconName: "ClearFilter" },
        iconProps: {},
        onRenderIcon: () => <FilterDismiss20Regular className={menuItemIconStyles} />,
        onClick: onClearSearch,
      } as IContextualMenuItem;
    }

    return null;

  }, [
    searchValue,
    waitFor,
    languageStrings,
    onClearSearch
  ]);

  return {
    menuItem_ClearSearch
  };
}